module.exports = __webpack_public_path__ + "img/star-h5.55545a98.svg";